import axios from 'axios';

export default {
  fetchClient({
    commit,
  }, id) {
    return axios.get(`/client/show/${id}`)
      .then((res) => {
        const hiddenFields = {
          fields: res.meta.invisibleFields,
          domain: 'client',
        };

        commit('app/setHiddenFields', hiddenFields, {
          root: true,
        });

        return res;
      });
  },
  saveClient(_, client) {
    return axios.post('/client', client);
  },
  deleteClient(_, client) {
    console.log(client);

    return axios.delete(`/client/${client.id}`);
  },
  fetchCompanyQuestionaryData(_, id) {
    return axios.get(`/company/questionary?tenantId=${id}`);
  },
  fetchCompanyTrainingData(_, id) {
    return axios.get(`/company/training?tenantId=${id}`);
  },
};
